import { AxiosError } from "axios";
import moment from "moment";
import { showNotification } from "../../../../../common/actionCreators/dispatchNotification";
import apiClient from "../../../../../common/api/apiClient";
import { ApiError } from "../../../../../common/api/apiResponse";
import {downloadBlob} from '../../../../../common/utils/downloadBlob';
import { ResourceDto } from "./resources.dtos";

const resourcesUrl = '/visitorInformation/resources/';

export const getResourcesApi = async () => {
    return await apiClient.get(resourcesUrl)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving facility resources.', 'error');
        }
        throw err;
    });
};

export const getResourceApi = async (request: string) => {
  return await apiClient.get(resourcesUrl + request)
  .then((res) => {
      return res.data.result;
  })
  .catch((err) => {
      console.log('In error', err);
      if (err && err.response) {
        const axiosError = err as AxiosError<ApiError>;
        if (axiosError.response) {
          console.log("response: ", axiosError.response)
          showNotification(axiosError.response?.data?.error?.message, 'error');
        }
      }
      else {
        showNotification('An error occurred while retrieving facility resource.', 'error');
      }
      throw err;
  });
};

export const updateResourceApi = async (request: ResourceDto) => {
  const data = new FormData();
  data.append("model", JSON.stringify(request));

  return await apiClient.put(resourcesUrl, data)
    .then((res) => {
      showNotification("Resource updated", 'success');
      return res.data.result;
    })
    .catch((err) => {
      console.log('In error', err);
      if (err && err.response) {
        const axiosError = err as AxiosError<ApiError>;
        if (axiosError.response) {
          showNotification(axiosError.response.data.error.message, 'error');
        }
      }
      else {
        showNotification('An error occurred while updating facility resource.', 'error');
      }
      throw err;
    });
};

export const createResourceApi = async (request: ResourceDto) => {
  const data = new FormData();

  if (request.fileUpload && request.fileUpload.length > 0) {
    request.fileUpload.forEach(file => data.append("file", file));
  }

  data.append("model", JSON.stringify(request));

  return await apiClient.post(resourcesUrl, data)
    .then((res) => {
      showNotification("Resource created", 'success');
      return res.data.result;
    })
    .catch((err) => {
      console.log('In error', err);
      if (err && err.response) {
        const axiosError = err as AxiosError<ApiError>;
        if (axiosError.response) {
          showNotification(axiosError.response.data.error.message, 'error');
        }
      }
      else {
        showNotification('An error occurred while creating facility resource.', 'error');
      }
      throw err;
    });
};

export const deleteResourceApi = async (resource: ResourceDto) => {
  return await apiClient.delete(resourcesUrl + resource.id)
  .then((res) => {
    showNotification("Resource deleted", 'success');
    return res.data.result;
  })
  .catch((err) => {
    if (err && err.response) {
      const axiosError = err as AxiosError<ApiError>;
      if (axiosError.response) {
        showNotification(axiosError.response.data.error.message, 'error');
      }
    }
    else {
      showNotification('An error occurred while deleting resource.', 'error');
    }
    throw err;
  });
}

export const downloadResourceApi = async (uploadName: string, mimeType: string, fileName: string) => {
  return await apiClient.get(resourcesUrl + 'download/' + uploadName, {
    responseType: "blob"
  }).then(res => {
    const blob = new Blob([res.data], { type: mimeType });
			return downloadBlob(blob, fileName);
  })
    .catch(err => {
      if (err && err.response) {
        const axiosError = err as AxiosError<ApiError>;
        if (axiosError.response) {
          showNotification(axiosError.response.data.error.message, 'error');
        }
      }

      throw err;
    });
};